import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useParams } from "react-router-dom";
import "swiper/css";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const clientsData = [
  {
    name: "Client 1",
    logo: `${BACKEND_URL}upload/other_agencies/others_01.jpg`,
  },
  {
    name: "Client 2",
    logo: `${BACKEND_URL}upload/other_agencies/others_02.jpg`,
  },
  {
    name: "Client 3",
    logo: `${BACKEND_URL}upload/other_agencies/others_03.jpg`,
  },
  {
    name: "Client 4",
    logo: `${BACKEND_URL}upload/other_agencies/others_04.jpg`,
  },
  {
    name: "Client 5",
    logo: `${BACKEND_URL}upload/other_agencies/others_05.jpg`,
  },
  {
    name: "Client 6",
    logo: `${BACKEND_URL}upload/other_agencies/others_06.jpg`,
  },
  {
    name: "Client 7",
    logo: `${BACKEND_URL}upload/other_agencies/others_07.jpg`,
  },
  {
    name: "Client 8",
    logo: `${BACKEND_URL}upload/other_agencies/others_08.jpg`,
  },
  {
    name: "Client 9",
    logo: `${BACKEND_URL}upload/other_agencies/others_09.jpg`,
  },
  {
    name: "Client 10",
    logo: `${BACKEND_URL}upload/other_agencies/others_10.jpg`,
  },
];

function ClientsSection() {
  const { section, id } = useParams();
  return (
    <section id="clients" className="clients section bgwhite">
      <div className="container" data-aos="fade-up">
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          loop={true}
          spaceBetween={30}
          slidesPerView={2}
          breakpoints={{
            576: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            992: { slidesPerView: 5 },
            1200: { slidesPerView: 6 },
          }}
        >
          {clientsData.map((client, index) => (
            <SwiperSlide
              key={index}
              className="d-flex align-items-center justify-content-center"
            >
              <img
                loading="lazy"
                decoding="async"
                src={client.logo}
                className="img-fluid"
                alt={client.name || "Image"}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default React.memo(ClientsSection);
